/**
 * Edit Organization Address Form Schema
 *
 * Reuses validation from addOrganizationAddress but loads local form configuration.
 */

import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

// Load form configuration from YAML
const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// Re-export types and schema from Add form
export {
  AddOrganizationAddressFormSchema,
  transformToApiRequest,
  validateField,
  type AddOrganizationAddressFormData,
} from '../addOrganizationAddress/schema'
